/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_TitleInputs */

const cs_idnes_title = /** @type {(inputs: Idnes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iDNES Reality`)
};

const en_idnes_title = /** @type {(inputs: Idnes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iDNES Reality`)
};

/**
* | output |
* | --- |
* | "iDNES Reality" |
*
* @param {Idnes_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_title = /** @type {((inputs?: Idnes_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_title(inputs)
	return cs_idnes_title(inputs)
});